import 'css-chunksrc/client/scenes/folderCreation/form/styles.scss';export default {
  "form": "_form_rcb7i_1",
  "group": "_group_rcb7i_5",
  "title": "_title_rcb7i_9",
  "folderSelection": "_folderSelection_rcb7i_15",
  "description": "_description_rcb7i_19"
};